import { useSearchParams } from 'react-router';
import { Booking } from 'types';

/**
 * Difference between using this hook and accessing `booking.appointment` is when user reloads the page
 * The appointment will have to be fetched before its available in the booking state
 * and sometimes we want to know whether the appointment is still loading or its not available
 */
const useIsSelectedAppointmentLoading = (booking: Booking) => {
    const [searchParams] = useSearchParams();

    return !booking.appointment && searchParams.has('appointmentId');
};

export { useIsSelectedAppointmentLoading };
